import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import InputField from "../../../Components/Masters/InputField";
import { Box, Button, Typography } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../utils/api";
import { validateNumberInput } from "../../../utils/validateFields";
import { useNavigate, useParams } from "react-router-dom";
import SelectField from "../../../Components/Masters/SelectField";
import DateField from "../../../Components/Masters/DateField";
import MessagePopup from "../../../Components/Masters/MessagePopup";
import contries from "../../Masters/Roles and Permissions/Country.json";
import AutoComplete from "../../../Components/Common/AutoComplete";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";

const GeneralDisclosure23 = ({hide}) => {
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const inputData = [
    {
      fieldName: "sustainabilityReportingPeriod",
      title:
        "a. What is the reporting period for your sustainability reporting, and how often is it conducted?",
      type: "array",
      fields: [
        {
          fieldName: "reportingPeriod",
          title: "Reporting Period",
          placeholder: "Select",
          type: "select",
          // options: generateFiscalYearRanges(5),
          options: ["Fiscal Year", "Calendar Year"],
        },
        {
          fieldName: "frequencyReported",
          title: "Frequency of Reporting",
          placeholder: "Enter Text",
          type: "text",
        },
      ],
    },
    {
      fieldName: "financialSustainabilityReportingPeriodDifference",
      title:
        "b. What is the reporting period for your financial reporting, and if it differs from your sustainability reporting period, please explain the reason for this discrepancy?",
      type: "array",
      fields: [
        {
          fieldName: "reportingPeriod",
          title: "Reporting Period",
          type: "select",
          placeholder: "Select",
          // options: generateCalenderYearRanges(5),
          options: ["Fiscal Year", "Calendar Year"],
        },
        {
          fieldName: "discrepancy",
          title: "Reason for Discrepancy",
          placeholder: "Enter Text",
          type: "text",
        },
      ],
    },
  ];

  const sustainableReportData = [
    {
      fieldName: "name",
      title: "Full Name",
      placeholder: "Enter Text",
      type: "text",
      width: "13rem",
    },
    {
      fieldName: "designation",
      title: "Designation",
      placeholder: "Enter Text",
      type: "text",
      width: "10rem",
    },
    {
      fieldName: "countryCode",
      title: "Country Code",
      placeholder: "+91",
      type: "select",
      width: "10rem",
      options: contries?.countries?.map((el) =>el?.code +  " (" + el?.dial_code + ")") || [],
    },
    {
      fieldName: "phone",
      title: "Phone No",
      placeholder: "Enter Number",
      type: "number",
      width: "10rem",
    },
    {
      fieldName: "email",
      title: "Email ID",
      placeholder: "Enter Text",
      type: "email",
      width: "12rem",
    },
  ];

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });


  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GeneralDisclosures2021`);
      const res1 = res?.data?.data?.GeneralDisclosures2021?.reportingPeriod;
      setData(res1);
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFormData({
      sustainabilityReportingPeriod: {
        reportingPeriod:
          data?.sustainabilityReportingPeriod?.reportingPeriod || "",
        frequencyReported:
          data?.sustainabilityReportingPeriod?.frequencyReported || "",
      },
      financialSustainabilityReportingPeriodDifference: {
        reportingPeriod:
          data?.financialSustainabilityReportingPeriodDifference
            ?.reportingPeriod || "",
        discrepancy:
          data?.financialSustainabilityReportingPeriodDifference?.discrepancy ||
          "",
      },
      sustainabilityReportPublicationDate:
        data?.sustainabilityReportPublicationDate || "", // Default empty string for date
      sustainabilityReportContact: {
        name: data?.sustainabilityReportContact?.name || "",
        designation: data?.sustainabilityReportContact?.designation || "",
        countryCode: data?.sustainabilityReportContact?.countryCode || "",
        phone: data?.sustainabilityReportContact?.phone || "",
        email: data?.sustainabilityReportContact?.email || "",
      },
    });
  }, [data]);

  const handleChange = (e, section) => {
    const { name, value } = e.target;

    // Validate phone number
    if (name === "phone" && !validateNumberInput(value)) return;

    // Reset errors for the specific field
    setErrors((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [name]: "",
      },
    }));

    // General case for nested keys
    setFormData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [name]: value,
      },
    }));

    console.log("Updated FormData:", formData);
  };

  const handleDateChange = ({ name, value }) => {
    // const { name, value } = e.target;
    console.log(name, value, "for the date");
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = () => {
    console.log("FormData: ", formData);
    const newErrors = {};
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Validate `inputData` fields
    inputData.forEach((section) => {
      section.fields.forEach((field) => {
        if (field.fieldName === "discrepancy") return;
        const fieldValue = formData?.[section.fieldName]?.[field.fieldName];

        // Initialize nested object for section errors if not already present
        if (!newErrors[section.fieldName]) {
          newErrors[section.fieldName] = {};
        }

        if (fieldValue === "") {
          // Mark as required if value is empty or missing
          newErrors[section.fieldName][
            field.fieldName
          ] = `This field is Required`;
        }
      });
    });

    // Validate `sustainabilityReportContact` fields
    if (!newErrors["sustainabilityReportContact"]) {
      newErrors["sustainabilityReportContact"] = {};
    }

    sustainableReportData.forEach((field) => {
      const fieldValue =
        formData?.["sustainabilityReportContact"]?.[field.fieldName];
      const isEmailField = field.fieldName === "email";

      if (fieldValue === "") {
        newErrors["sustainabilityReportContact"][
          field.fieldName
        ] = `This field is Required`;
      } else if (isEmailField && !emailPattern.test(fieldValue)) {
        // Validate email field
        newErrors["sustainabilityReportContact"][field.fieldName] =
          "Invalid Email Address";
      }
    });

    // Validate `sustainabilityReportPublicationDate`
    if (formData?.sustainabilityReportPublicationDate === "") {
      newErrors[
        "sustainabilityReportPublicationDate"
      ] = `This field is Required`;
    }

    setErrors(newErrors);

    // Check if there are any errors
    const hasErrors = Object.values(newErrors).some((error) => {
      if (typeof error === "object") {
        // Check for nested errors
        return Object.values(error).some((nestedError) => nestedError);
      }
      return !!error; // Top-level errors
    });

    return !hasErrors; // Returns true if there are no errors
  };

  const handleSubmit = async () => {
    if (!disabled) {
      console.log(!validateForm());
      if (!validateForm()) return;

      let transformedData2 = {
        reportingPeriod: formData,
        submitted2_3: true,
        type: "GeneralDisclosures2021",
      };
      console.log("abc", transformedData2);
      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/general-disclosure/2-4/${id}`);
      } catch (error) {
        console.log(error);
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/general-disclosure/2-4/${id}`);
    }
  };

  const renderContent = ({hide}) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />
      <p className={styles.main_heading} style={{ marginBottom: hide ? "-1rem" : "1.5rem" }}>
        2-3 Reporting period, frequency and contact point
      </p>
      {/* a */}
      {inputData.map((section, sectionIndex) => (
        <Box>
          <Box sx={{ display: "flex", gap: 0.5 }}>
            {/* <p className={styles.ques_heading}>{section.letter}</p> */}
            <p className={styles.ques_heading} style={{textIndent:sectionIndex===1&&"-1.2rem",paddingLeft:sectionIndex===1&&"1.2rem" }}>{section.title}</p>
          </Box>
          <Box key={sectionIndex} sx={{ display: "flex", gap: 3 }}>
            {section.fields.map((el, index) => (
              <Box key={index} sx={{ width: "100%", ml: 2.5 }}>
                <Typography sx={{ fontWeight: 500, fontSize: "15px",}}>
                  {el.title}
                </Typography>
                {el.type === "select" ? (
                  <SelectField
                    placeholder={el.placeholder || "Enter Text"}
                    name={el.fieldName}
                    value={formData?.[section.fieldName]?.[el.fieldName] || ""}
                    handleChange={(e) => handleChange(e, section.fieldName)}
                    options={el.options}
                    disable={disabled}
                    width="100%"
                    errors={!!errors[section.fieldName]?.[el.fieldName]} // Check if there's an error for this field
                  />
                ) : (
                  <InputField
                    placeholder={el.placeholder || "Enter Text"}
                    fieldName={el.fieldName}
                    disabled={disabled}
                    value={formData?.[section.fieldName]?.[el.fieldName] || ""}
                    handleChange={(e) => handleChange(e, section.fieldName)}
                    errors={!!errors[section.fieldName]?.[el.fieldName]} // Check if there's an error for this field
                  />
                )}
                <p
                  style={{
                    lineHeight: "1.2",
                    margin: "2px 0",
                    marginTop:
                      el?.fieldName === "reportingPeriod" ? "-3px" : "5px",
                    color: "#d34040",
                    fontSize: "10px",
                    fontStyle: "italic",
                  }}
                >
                  {errors[section.fieldName]?.[el.fieldName]}
                </p>
              </Box>
            ))}
          </Box>
        </Box>
      ))}
      {/* c */}
      <p className={styles.ques_heading} style={{marginBottom: hide ? "-0.9rem" : "0rem"}}>
        c. When was your sustainability report or reported information
        published?
      </p>
      <Box sx={{ width: "46%", ml: 2.5 }}>
        <DateField
          handleChange={handleDateChange}
          disable={disabled}
          name={"sustainabilityReportPublicationDate"}
          placeholder={"Select Date"}
          value={formData?.sustainabilityReportPublicationDate}
          errors={errors["sustainabilityReportPublicationDate"] && true}
        />
      </Box>
      {errors["sustainabilityReportPublicationDate"] && (
        <p
          style={{
            lineHeight: "1.2",
            margin: "2px 0",
            marginTop: "5px",
            color: "#d34040",
            fontSize: "10px",
            fontStyle: "italic",
            marginLeft: "1.5rem",
          }}
        >
          {errors["sustainabilityReportPublicationDate"]}
        </p>
      )}
      <p className={styles.ques_heading}>
        d. Who should be contacted for inquiries regarding your sustainability
        report or reported information?
      </p>
      <Box sx={{ display: "flex", gap: 1, ml: 2.5 }}>
        {sustainableReportData.map((el,i) => (
          <Box sx={{ width: el.width }}>
            <Typography sx={{ fontWeight: 500, fontSize: "15px",fontFamily:"inter",lineHeight:"22px",}}>
              {el.title}
            </Typography>
            {el.type === "select" ? (
              <AutoComplete
                placeholder={el.placeholder || "Enter Text"}
                name={el.fieldName}
                disabled={disabled}
                value={
                  formData?.["sustainabilityReportContact"]?.[el.fieldName] ||
                  ""
                }
                handleChange={(e) =>
                  handleChange(e, "sustainabilityReportContact")
                }
                options={el.options}
                width="100%"
                errors={!!errors["sustainabilityReportContact"]?.[el.fieldName]} // Check if there's an error for this field
              />
            ) : (
              <InputField
                placeholder={el.placeholder || "Enter Text"}
                fieldName={el.fieldName}
                disabled={disabled}
                value={
                  formData?.["sustainabilityReportContact"]?.[el.fieldName] ||
                  ""
                }
                handleChange={(e) =>
                  handleChange(e, "sustainabilityReportContact")
                }
                errors={!!errors["sustainabilityReportContact"]?.[el.fieldName]} // Check if there's an error for this field
              />
            )}

            {errors["sustainabilityReportContact"]?.[el.fieldName] && (
              <p
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  marginTop: "5px",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                }}
              >
                {errors["sustainabilityReportContact"][el.fieldName]}
              </p>
            )}
          </Box>
        ))}
      </Box>
      {/* 2 */}
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({hide})}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({hide})
      )}
    </>
  );
};

export default GeneralDisclosure23;
